// my attempt at cocoon
// stolen partially from GoRails and modified
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "links", "template", 'input', 'container']

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields"
  }

  addAssociation(event) {
    event.preventDefault()

    // Override this default if you have nested-nested-fields (deeply nested). This
    // way the deeply nested field template are not touched by the outer nested fields.
    const recordKey = this.templateTarget.dataset.newRecordKey || "NEW_RECORD";

    // Replace all instances of the record key with a unique timestamp ID
    var content = this.templateTarget.innerHTML.replace(new RegExp(recordKey, "g"), Date.now());
    this.containerTarget.insertAdjacentHTML('beforeend', content)
    const newestInput = this.inputTargets[this.inputTargets.length - 1]
    if(!newestInput) {
        return
    }
    newestInput.focus()
    const position = newestInput.closest('.nested-fields').querySelector('input[name*="[position]"]')
    if(position) {
      position.value = this.inputTargets.length
    }
    return newestInput
  }

  removeAssociation(event) {
    event.preventDefault()

    const confirmationMessage = event.currentTarget.dataset.confirm;
    if (confirmationMessage && !window.confirm(confirmationMessage)) {
      return; // Stop if user cancels
    }

    let wrapper = event.target.closest("." + this.wrapperClass)

    if (wrapper.dataset.newRecord == "true") {
      // For new records, completely clean up Trix editors to prevent form validation issues
      this.cleanupTrixEditors(wrapper);
      wrapper.remove()
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1
      // Clean up Trix editors in hidden items to prevent validation issues
      this.cleanupTrixEditors(wrapper);
      // use '!important' here as certain Bootstrap classes (e.g. d-flex) can
      // lead to the wrapper still being visible
      wrapper.style.setProperty("display", "none", "important");
    }
  }

  cleanupTrixEditors(wrapper) {
    const trixEditors = wrapper.querySelectorAll('trix-editor');
    trixEditors.forEach(editor => {
      // Remove validation attributes
      editor.removeAttribute('required');
      editor.removeAttribute('data-trix-validate');
      
      // Get the connected hidden input
      const inputId = editor.getAttribute('input');
      const hiddenInput = document.getElementById(inputId);
      
      if (hiddenInput) {
        // Remove validation attributes from hidden input
        hiddenInput.removeAttribute('required');
        hiddenInput.removeAttribute('data-trix-validate');
        
        // Disconnect the Trix editor by removing the input connection
        editor.removeAttribute('input');
        
        // Clear the hidden input value to prevent any submission
        hiddenInput.value = '';
        
        // Mark the input as disabled to exclude it from form validation
        hiddenInput.disabled = true;
      }
      
      // Disconnect the Trix editor from form validation entirely
      editor.addEventListener('trix-before-initialize', (e) => e.preventDefault());
      
      // Clear the editor content
      if (editor.editor) {
        editor.editor.loadHTML('');
      }
    });
  }

  moveCursorToEnd(inputElement) {
    const range = document.createRange();
    const selection = window.getSelection();
    range.setStart(inputElement, inputElement.childNodes.length);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}
